import { useState } from "react";
import axios from "@/api/axios";
import { useSession } from "./useSession";

const useFormData = () => {
  const { token } = useSession();
  const [postIsLoading, setPostIsLoading] = useState(false);
  const [postError, setPostError] = useState(null);

  const postData = async (userData, url) => {
    setPostIsLoading(true);
    setPostError(null);
    const language = localStorage.getItem("ln") || "en"; // <-- Language fallback

    try {
      const response = await axios.post(url, userData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: "Bearer " + token,
          "Accept-Language": language, // <-- Inject Accept-Language
        },
      });
      return response.data; // Return the response data
    } catch (err) {
      setPostError(err);
      setPostIsLoading(false);

      throw err;
    } finally {
      setPostIsLoading(false);
    }
  };

  return { postData, postIsLoading, postError };
};

export default useFormData;
